import KommerPoster from 'src/components/kommendefilmer/KommerPoster';
import KommerTextRow from 'src/components/kommendefilmer/KommerTextRow';
import SPosterContainer from 'src/components/kommendefilmer/PosterContainer';
import SSectionTitle from 'src/components/kommendefilmer/SectionTitle';
import STextListContainer from 'src/components/kommendefilmer/TextListContainer';
import { format, isSameYear, parse } from "date-fns";
import locale from "date-fns/locale/nb";
import { Movie } from 'src/lib/movieinfo/movieinfotypes';
;

//#region [Props]
type MonthlyMoviesPostersProps = {
	monthKey: number;
	movies?: Movie[];
	showTextList: boolean;

};
//#endregion

//#region [Component]
export default function MonthlyMovies({ monthKey, movies, showTextList }: MonthlyMoviesPostersProps) {
	if ((movies?.length ?? 0) === 0) {
		return null;
	}
	const d = new Date();
	const month = parse(monthKey.toFixed(2), 'yyyy.MM', d);
	const dateFormat = isSameYear(month, d) ? "thisyear" : "year";
    const monthTitle = format(month, "MMMM yyyy", { locale });
	if (showTextList) {
		return <STextListContainer>
			<SSectionTitle>{monthTitle}</SSectionTitle>
			{movies!.filter(m => m.isPremiereConfirmed).map(movie => <KommerTextRow key={movie.mainVersionId} film={movie} dateFormat={dateFormat} />)}
			{movies!.filter(m => !m.isPremiereConfirmed).map(movie => <KommerTextRow key={movie.mainVersionId} film={movie} dateFormat={dateFormat} />)}
		</STextListContainer>;
	}
	return <SPosterContainer>
		<SSectionTitle>{monthTitle}</SSectionTitle>
		{movies!.filter(m => m.isPremiereConfirmed).map(movie => <KommerPoster key={movie.mainVersionId} film={movie} dateFormat={dateFormat} width={235}/>)}
		{movies!.filter(m => !m.isPremiereConfirmed).map(movie => <KommerPoster key={movie.mainVersionId} film={movie} dateFormat={dateFormat} width={235}/>)}
	</SPosterContainer>;
}
//#endregion
